var map = {
	"./Canvas.vue": 20241,
	"./DocumentIframe.js": 77229,
	"./Gallery.vue": 88484,
	"./ModeAndViewportToolbar.vue": 72402,
	"./ToolbarTop.vue": 51847,
	"./VersionActions.vue": 78076,
	"./tooltip.js": 52685
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48513;